import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';
import { SortDirection } from '../../../../utils/constants';

export const filterFields = {
  orderNumber: 'orderNumber',
  statusIDs: 'statusIDs',
  requestor: 'requestor',
  rushOrder: 'rushOrder',
  clientIDs: 'clientIDs',
  reportAddressIDs: 'reportAddressIDs',
  invoiceAddressIDs: 'invoiceAddressIDs',
  companyName: 'companyName',
  ShipCity: 'ShipCity',
  supplyTypes: 'supplyTypes',
  templateNo: 'templateNo',
  dueDateFrom: 'dueDateFrom',
  dueDateTo: 'dueDateTo',
  orderDateFrom: 'orderDateFrom',
  orderDateTo: 'orderDateTo',
  shipToFacility: 'shipToFacility',
  shipToCompany: 'shipToCompany',
  functionality: 'functionality',
  scenarioIDs: 'scenarioIDs'
};
const initialFilterState = {
  orderNumber: '',
  statusIDs: [],
  requestor: '',
  rushOrder: false,
  clientIDs: [],
  reportAddressIDs: [],
  invoiceAddressIDs: [],
  scenarioIDs: [],
  companyName: '',
  ShipCity: '',
  supplyTypes: [],
  shipToFacility: null,
  shipToCompany: [],
  dueDateFrom: null,
  dueDateTo: null,
  orderDateFrom: null,
  orderDateTo: null,
  templateNo: null,
  functionality: 'Order'
};

const initialPageState = {
  page: 0,
  pageSize: 20,
  sortColumn: 'CreatedOn',
  sortDirection: SortDirection.Desc,
};
export const OrderSearchsliceName = 'OrderSearch';
const OrderSearchSlice = createSearchPageSlice({
  sliceName: OrderSearchsliceName,
  filterFields,
  initialFilterState,
  initialPageState
});
export const OrderSearchActions = OrderSearchSlice.actions;
export default OrderSearchSlice.reducer;
